export default "__VITE_ASSET__CbAJRtFk__"